import axios from "axios";
import config from "./../../../config/config";
import { comerceNumber } from "../../consultForm/Helpers/constants";
import { GetToken } from "../../consultForm/Requests/movistar";
import { buildDataMovistar } from "./helpers";
import { UFStorage } from "../Helper/Helper";
import { findLastInvoice } from "../services/helpers";
import { checOnlineStatus } from '../../consultForm/Helpers'
import { decryptData } from "../../Utils/Utils";
declare const window: any;

export const ADD_INVOICE_TO_CART = async (params: any, ultraFacturas: any, turnstileToken?: string) => {

    let obj: {
        result: boolean,
        [key: string]: any
    } = { result: false };

    let pk: any = {
        2: config.REACT_APP_TELEBUCARAMANGA_RECAUDO_PUBLIC_KEY,
        3: config.REACT_APP_METROTEL_RECAUDO_PUBLIC_KEY,
    }

    let domain: any = {
        2: config.REACT_APP_TELEBUCARAMANGA_DOMINIO,
        3: config.REACT_APP_METROTEL_DOMINIO,
    }

    let filial = comerceNumber[sessionStorage.getItem('filial') || 'movistar'];

    let paramId: any = {
        1: 'identificacionEmpresa',
        2: 'facturaId',
        3: params.invoiceType ? params.invoiceType : params.option,
    }
    let dataMovistar = buildDataMovistar(params, ultraFacturas);

    let data_M_T = {
        "band": config.REACT_APP_TELEBUCARAMANGA_BAND,
        "referencia": params.paymentRef,
        "option": params.invoiceType ? params.invoiceType : params.option,
        "dominio": domain[filial],
        "ultraFacturas": ultraFacturas,
        "shoppingCartId": sessionStorage.getItem('shoppingCartId') ? sessionStorage.getItem('shoppingCartId') : null,
        "public_key": pk[filial]
    }

    let dataRequest: any = {
        1: dataMovistar,
        2: data_M_T,
        3: data_M_T,
    }

    let endpoint = filial === 1 ?
        config.EPAYCO_REST_RECAUDO_API_INVOICE :
        config.REACT_APP_AMBIENTE + '/api/recaudo/proyecto/consultar/facturas';

    const isOnline = await checOnlineStatus();
    if (!isOnline) {
        return {
            result: false,
            message: config.alertas.conexion
        }
    }
    let token = await GetToken();
    /*
    const tokenCaptcha = await window.grecaptcha.execute(config.CaptchaKey, {
        action: 'RequestInvoiceMovistar',
    });
    */
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token.token}`,
        "X-api-key": '',
        ...(turnstileToken && { "X-Api-Validation": turnstileToken })
    }
    try {
        await axios({
            method: 'post',
            url: endpoint,
            data: dataRequest[filial],
            headers: filial == 1 ? headers : { "X-api-key": '' }
        })
            .then(async (resp: any) => {
                if (resp.status === 200) {
                    if (resp.data.data === 1407) {
                        obj.result = false
                        obj.timeout = true
                        obj.message = 'Time out!'
                        return obj;
                    }

                    let ultrafacturas = null;

                    if (filial === 1) {
                        let decrypData = decryptData(resp.data.data);
                        ultrafacturas = decrypData.ultraFacturas;
                    } else {
                        ultrafacturas = resp.data.data.ultraFacturas;
                    }


                    let invoice = findLastInvoice(params.paymentRef, paramId[filial], ultrafacturas.facturas);
                    let validInvoice = !!(invoice.total || invoice.extra11);
                    let UFss = JSON.parse(sessionStorage.getItem(UFStorage) || "{}");

                    if (invoice) {
                        obj.ultrafacturas = validInvoice ? ultrafacturas : UFss;
                        obj.result = true
                        obj.factura = !!invoice.total
                        obj.message = 'Facturas consultadas con éxito';
                        obj.invRequest = validInvoice ? false : invoice;
                    }
                    else {
                        obj.result = false
                        obj.message = 'Error consultando facturas'
                    }
                }
                else {
                    obj.result = false
                    obj.message = 'Error consultando facturas'
                }
            })
            .catch((e: any) => {
                obj.result = false
                obj.message = config.alertas.facturas
            })
    }
    catch (e) {
        obj.result = false
        obj.message = config.alertas.facturas
    }

    return obj;
}

export const DomiciliationEspressSend = (data: any) => {
    const url = config.REACT_APP_AMBIENTE + '/api/domiciliation/express';
    return axios.post(url, data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const DomiciliationEspressValidationClient = async (data: any) => {
    let dataToken = await GetToken(); // Obtiene el token de forma asíncrona
    let token = dataToken.token
    const url = config.REACT_APP_AMBIENTE + '/api/recaudo/data/subscription';

    if (!dataToken) {
        console.error('No se pudo obtener el token de autenticación.');
        throw new Error('Authentication token not found.');
    }

    return axios.post(url, data, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` // <--- ¡Aquí está la clave!
        },
    });
};
